import React from 'react';
import { Box, IconButton } from '@mui/material';
import NavigateBefore from '@mui/icons-material/NavigateBefore';
import NavigateNext from '@mui/icons-material/NavigateNext';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    maxWidth: '70%',
    marginTop: theme.spacing(0.25)
  },
  period: {
    fontSize: '1.05rem',
    fontWeight: theme.typography.fontWeightMedium,
    display: 'flex',
    alignItems: 'center'
  },
  icon: {
    color: theme.palette.text.primary
  }
}));
type InsightsDateRangeArrowsProps = {
  disableNext: boolean;
  disablePrevious: boolean;
  updateNext: () => void;
  updatePrevious: () => void;
};
export const InsightsDateRangeArrows: React.FC<InsightsDateRangeArrowsProps> = ({
  disableNext,
  disablePrevious,
  updateNext,
  updatePrevious
}: InsightsDateRangeArrowsProps) => {
  const classes = useStyles();

  return (
    <Box className={classes.root} data-testid="insight-period-arrow">
      <IconButton
        size="small"
        data-testid="insight-period-previous"
        disabled={disablePrevious}
        onClick={updatePrevious}
        className={classes.icon}
      >
        <NavigateBefore />
      </IconButton>
      <IconButton
        size="small"
        data-testid="insight-period-next"
        disabled={disableNext}
        onClick={updateNext}
        className={classes.icon}
      >
        <NavigateNext />
      </IconButton>
    </Box>
  );
};
